import { createFileRoute } from '@tanstack/react-router';

import { securitySearchSchema } from '@/components/settings/security/security-search';
import { SecurityTab } from '@/components/settings/security/security-tab';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute(
  '/_authenticated/agency/settings/security',
)({
  loader: () => loadNamespaces('auth', 'settings'),
  validateSearch: securitySearchSchema,
  staticData: {
    title: 'route.settings_security.title',
  },
  component: SecurityTab,
});
